<template>
    <aside id="sidebar" class="navlight" :class="{ 'expand': expandSidebar }" @mouseout="handleMouseOut"
        @mouseover="handleMouseOver">
        <ul class="sidebar-nav">
            <SidebarItem v-for="(menuItem, index) in menuOptions" :key="index" :item="menuItem" />
        </ul>
    </aside>
</template>

<script setup>
import { useRouter } from 'vue-router';
import SidebarItem from './SidebarItem.vue';
import {
    ref,
    inject, watch
} from 'vue';

import buildSidebarTree from '@/utils/buildRoutes';
const expandSidebar = inject('expandSidebar');


// Encontrar la ruta raíz ('home') y extraer sus hijos
const router = useRouter();
const routes = router.getRoutes().filter(r => !!r.name);
const menuOptions = buildSidebarTree(routes);


const hideTimeout = ref(null);

const handleMouseOver = () => {
    if (hideTimeout.value) {
        clearTimeout(hideTimeout.value);
        hideTimeout.value = null;
    }
};

const handleMouseOut = () => {

    if (expandSidebar.value) {
        hideTimeout.value = setTimeout(() => {
            expandSidebar.value = false;
            hideTimeout.value = null;
            const openSubmenus = document.querySelectorAll('.sidebar-dropdown.show');
            openSubmenus.forEach(submenu => {
                submenu.classList.remove('show');
            });
        }, 100); // Ajusta el tiempo de espera según sea necesario

    }
};

watch(expandSidebar, (newValue, oldValue) => {
    if (newValue != oldValue) {
        if (newValue === true) {

            const sidebarDropdowns = document.querySelectorAll('.sidebar-dropdown');
            sidebarDropdowns.forEach(dropdown => {
                const hasActiveLink = dropdown.querySelector('.router-link-exact-active');
                if (hasActiveLink) {
                    dropdown.classList.add('collapse', 'show');
                }
            });
        }
    }
})
</script>

<style>
#sidebar {
    position: fixed;
    top: 40px;
    width: 50px;
    height: 100%;
    min-width: 50px;
    z-index: 1000;
    transition: all .25s ease-in-out;
    display: flex;
    flex-direction: column;
}

#sidebar.expand {
    width: 260px;
    min-width: 260px;
}

.sidebar-nav {
    padding: 1rem 0;
    flex: 1 1 auto;
}

a.sidebar-link {
    display: block;
    padding: 0.5rem 1rem;
    text-decoration: none;
    font-size: 10pt;
    white-space: nowrap;
    border-left: 3px solid transparent;
}

/* .sidebar-link i {
    width: 20px;
} */

/* .sidebar-link span {} */

.submenu2 {
    padding-left: 15px !important;
}

.submenu3 {
    padding-left: 20px !important;
}

a.sidebar-link:hover {
    background-color: #408c68;
    color:var(--bs-success-text-emphasis)!important;
    /* border-left: 3px solid  #7f2929; */
    /*SE QUITA, AL POSICIONARSE EN LA OPCION SE DESPLAZABA EL ICONO*/
}

.sidebar-item {
    position: relative; /*NO VEO QUE CAMBIE ALGO*/
}

#sidebar:not(.expand) .sidebar-item .sidebar-dropdown {
    position: absolute;
    top: 0;
    left: 70px;
    background-color: #b77575;
    padding: 0;
    min-width: 15rem;
    display: none;
}

#sidebar:not(.expand) .sidebar-item:hover .has-dropdown+.sidebar-dropdown {
    display: none;
    max-height: 15em;
    width: 100%;
    opacity: 1;
}

#sidebar:not(.expand) .sidebar-link span {
    display: none;
}

#sidebar.expand .sidebar-link[data-bs-toggle="collapse"]::after {
    border: solid;
    border-width: 0 .075rem .075rem 0;
    content: "";
    display: inline-block;
    padding: 2px;
    position: absolute;
    right: 1.5rem;
    top: 0.85rem;
    transform: rotate(-135deg);
    transition: all .2s ease-out;
}

#sidebar.expand .sidebar-link[data-bs-toggle="collapse"].collapsed::after {
    transform: rotate(45deg);
    transition: all .2s ease-out;
}

#sidebar.expand .sidebar-dropdown {
    background-color: #add7c312;
}
</style>